const Element = (el) => {
  const _computed = () => {
    return el?getComputedStyle(el):[]
  }
  const _outerWidth = (bool) => {
    bool = typeof bool === 'boolean' ? bool : false
    const width = el?.offsetWidth
    return bool
      ? width + parseInt(_computed().marginLeft) + parseInt(_computed().marginRight)
      : width
  }
  const _outerHeight = (bool) => {
    bool = typeof bool === 'boolean' ? bool : false
    const height = el?.offsetHeight
    return bool
      ? height + parseInt(_computed().marginTop) + parseInt(_computed().marginBottom)
      : height
  }
  const _lineHeight = () => {
    return parseInt((_computed().lineHeight), 10)
  }
  return {
    outerWidth: _outerWidth,
    outerHeight: _outerHeight,
    lineHeight: _lineHeight
  }
}

export {
  Element
}
